/**
 * SHA-256 hashing for Meta Advanced Matching parameters.
 * Meta requires SHA-256(lowercased, trimmed) for em / ph / fn / ln / external_id.
 * Spec: https://developers.facebook.com/docs/meta-pixel/advanced/advanced-matching/
 */

/**
 * Returns SHA-256 hex digest of the input, after lowercasing and trimming.
 * Empty / nullish input returns empty string so callers can skip blank fields.
 */
export async function sha256Hex(input: string | null | undefined): Promise<string> {
  if (!input) return '';
  const normalised = input.trim().toLowerCase();
  if (!normalised) return '';

  const encoder = new TextEncoder();
  const data = encoder.encode(normalised);
  const buffer = await crypto.subtle.digest('SHA-256', data);

  const bytes = new Uint8Array(buffer);
  let hex = '';
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, '0');
  }
  return hex;
}
